import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: 'app-forms-builder-polished-confirm',
  templateUrl: './forms-builder-polished-confirm.component.html',
  styleUrls: ['./forms-builder-polished-confirm.component.css']
})
export class FormsBuilderPolishedConfirmComponent implements OnInit {

  message: string = '';

  constructor(
    public dialogRef: MatDialogRef<FormsBuilderPolishedConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.message = this.data.message;
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

}

